import _ from 'lodash'
/**
 * 返回方括号包围的数据序列
 * 如: '嫩田[name=hhh, age=1243, value=999],嫩田[name=, num=hhhhhh]'
 * 返回: [ 'name=hhh, age=1243, value=999', 'name=, num=hhhhhh' ]
 * @param {string} str 输入的字符串
 */
function getLines(str) {
  const lines = [];
  let level = 0;
  let startPos = 0;
  for (let i in str) {
    const value = str[i];

    if (value === '[') {
      if (level === 0) {
        startPos = i;
      }
      level++;
    } else if (value === ']') {
      level--;
      if (level === 0) {
        const line = str.substring(parseInt(startPos) + 1, i);
        lines.push(line);
      }
    }
  }
  return lines;
}

const split = token => v => String.prototype.split.call(v, token)

/**
 * 返回数据项生成的对象列表
 * @param {string} target 待转换数据
 */
export default function str2obj(target) {
  const table = getLines(target).map(v => split(/,\s*/)(v).map(split(/=\s*/)))
  return table.map(v => _.zipObject(..._.unzip(v)))
}
